const API_BASE_URL = 'https://yesdone.com';

export default API_BASE_URL;
